import React from 'react';

export default function Tabs({ items, activeIndex = 0, onSelect }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {items.map((item, idx) => (
        <button
          key={item}
          type="button"
          onClick={() => onSelect?.(idx)}
          className={
            idx === activeIndex
              ? 'rounded-full bg-black text-white text-xs font-semibold px-4 py-2'
              : 'rounded-full bg-[#ECECEC] text-gray-700 text-xs font-semibold px-4 py-2 hover:bg-[#E2E2E2] transition-colors'
          }
        >
          {item}
        </button>
      ))}
    </div>
  );
}

